import client from "./client";

const getPayouts = () => client.get("/subsidiary/payout/all");

export default { getPayouts };
